<template>
    <div>
        <HeaderSection icon="far fa-calculator" title="Consecutivos">
            <template slot="buttons">
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="goToBack">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>
        <br>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-select
                    filterable
                    @change="filterByOffice(cat_office_id)"
                    v-model="cat_office_id"
                    style="width: 100%"
                    placeholder="Seleccione una Oficina">
                    <el-option
                        v-for="item in offices"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>
        <br>

        <el-row :gutter="15">
            <el-col :span="12" v-for="(item, key) in counts" :key="key" align="center">
                <el-card shadow="never" class="box-card">
                    <div slot="header">
                        Contadores: {{item[0].office.name}}
                    </div>
                    <el-form ref="form" :model="item[key]" label-width="120px" label-position="top">
                        <el-row :gutter="5" v-for="(item2, key2) in item" :key="key2">
                            <el-form-item label="Consecutivo Expedientes" v-if="item2.type == 1">
                                <el-col :span="8">
                                    <el-input-number v-model="item2.countRecord"></el-input-number>
                                </el-col>
                                <el-col :span="8">
                                    <el-tag>Siguiente Expediente: {{currentYear
                                        +''+item2.office.oldId+'/'+(item2.countRecord + 1)}}
                                    </el-tag>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="Consecutivo Constancia" v-if="item2.type == 2">
                                <el-col :span="8">
                                    <el-input-number v-model="item2.countConstancy"></el-input-number>
                                </el-col>
                                <el-col :span="8">
                                    <el-tag>Siguiente Constancia: {{currentYear +
                                        '' + item2.office.oldId +'/' + (item2.countConstancy + 1)}}
                                    </el-tag>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="Consecutivo Permisos" v-if="item2.type == 3">
                                <el-col :span="8">
                                    <el-input-number v-model="item2.countPermission"></el-input-number>
                                </el-col>
                                <el-col :span="8">
                                    <el-tag>Siguiente Permiso: {{customPermission(item2.countPermission)}}
                                    </el-tag>
                                </el-col>
                            </el-form-item>
                            <el-row>
                                <el-col align="end">
                                    <el-button type="success" @click="updateCounts(item2)">
                                        Actualizar
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-row>

                    </el-form>
                </el-card>
            </el-col>
        </el-row>


    </div>
</template>

<script>
    import HeaderSection from "./HeaderSection";

    export default {
        components: {
            HeaderSection
        },

        computed: {
            userInfo() {
                return this.$store.state.user.user;
            },
            currentYear() {
                return new Date().getFullYear();
            },
        },

        data() {
            return {
                counts: [],
                offices: [],
                cat_office_id: null
            }
        },

        created() {
            this.filterByOffice();
        },

        methods: {
            goToBack() {
                this.$router.push('/administracion')
            },

            filterByOffice(office = null) {
                let _office = office ? office : this.userInfo.cat_office_id;

                axios.get('/api/get-counts', {params: {office: _office}}).then(response => {
                    if (response.data.success) {
                        this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                        this.counts = _.groupBy(response.data.counts, 'cat_office_id');
                        this.offices = response.data.offices;
                    } else {
                        this.$store.dispatch('notifications/warning', {msg: response.data.message}, {root: true});

                    }
                }).catch(e => {
                    this.$store.dispatch('notifications/error', {msg: 'Error al procesar su solicitud'}, {root: true});
                })
            },

            customPermission(permission) {
                let _permission = '';
                if (permission >= 0) {
                    _permission = this.currentYear + '' + (permission + 1)
                }
                return _permission
            },

            updateCounts(updateCounts) {
                axios.post('/api/update-counts', {...updateCounts}).then(response => {
                    if (response.data.success) {
                        this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                        this.counts = _.groupBy(response.data.counts, 'cat_office_id');
                        this.offices = response.data.offices;
                        this.filterByOffice();
                        if (this.counts.legth == 0) {
                            this.$store.dispatch('notifications/warning', {msg: 'No se han iniciado trámites en esta oficina'}, {root: true});
                        }
                    } else {
                        this.$store.dispatch('notifications/warning', {msg: response.data.message}, {root: true});

                    }
                }).catch(e => {
                    this.$store.dispatch('notifications/error', {msg: 'Error al procesar su solicitud'}, {root: true});
                })
            }
        }

    }
</script>

<style scoped>

</style>
